/**
 * Prices are returned from ECAPI as floats :-(
 *
 * This would lead to rounding errors in calculations, such as sleeve price - 9.09 * 7 = 63.629999999999995
 *
 * In order to account for this, in this app's domain we represent the prices as integers created using
 * the below multiplier.
 *
 * At point of format, the multiplier is removed
 */
export const PRICE_REPRESENTATION_MULTIPLIER = 1000;

/**
 * Common type for storing currency format props shared across components
 */
export type CurrencyFormatConfig = {
  /** Like 'es' or 'es-ES'. @note Needs to work with Intl config */
  locale: string;
  /** Like 'EUR' */
  currencyCode: string;
};

export type PricingModel = 'CAPSULE' | 'SLEEVE';

export type Pricing = {
  price: number;
  pricePerCapsule?: number;
  pricePerSleeve?: number;
  pricePerWeight?: number; // Placeholder
  strikethroughPrice?: number; // Placeholder
};

export type PriceFormat = {
  decimalSeparator: string;
  thousandsGroupingSeparator: string;
  minusSign: string;
  minimumFractionDigits: number;
  maximumFractionDigits: number;
  pattern: string;
};
